import '@/index.css';
import { createRoot } from 'react-dom/client';
import { HomePage } from '@/pages/HomePage';
import { initializeLooplayAuth, initializeLooplayLifecycleTracking } from '@/looplay';

initializeLooplayAuth();
initializeLooplayLifecycleTracking();

createRoot(document.getElementById('root')!).render(<HomePage />);
